// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__vKWzO","col":"CardReaderDesc_col__2oMg9","label":"CardReaderDesc_label__2dpqr"};